// extracted by mini-css-extract-plugin
module.exports = {"item":"SecondaryNavItem_item__dQ6ji","list":"SecondaryNavItem_list__M0TS4","button":"SecondaryNavItem_button__mav3M"};